
import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import HTMLDisplay from "../../../utils/HTMLDisplay";
import { useParams } from "react-router-dom";
import "../../../assets/css/FaqSection.css";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

function FaqSection() {
  const { section, id } = useParams();

  const [activeIndex, setActiveIndex] = useState(null);
  const [faqData, setFaqData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(false);

  const fetchFaqData = useCallback(async () => {
    setLoading(true);
    setLoadError(false);

    try {
      await axios.get("sanctum/csrf-cookie");

      const response = await axios.get(
        `${BASE_URL}faqdata?visibility[eq]=publish`
      );

      if (response?.data?.status === 200) {
        setFaqData(
          Array.isArray(response.data.allData)
            ? response.data.allData
            : []
        );
      } else {
        setFaqData([]);
        setLoadError(true);
      }
    } catch (error) {
      console.error("Error fetching FAQ data:", error);
      setLoadError(true);
      setFaqData([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchFaqData();
    setActiveIndex(null);
  }, [fetchFaqData, section, id]);

  const toggleFAQ = (index) => {
    setActiveIndex((previous) =>
      previous === index ? null : index
    );
  };

  if (!loading && !loadError && faqData.length === 0) {
    return null;
  }

  return (
    <section id="faq" className="fsq-section section">
      <div className="container">
        <header className="fsq-heading">
          <span className="fsq-eyebrow">
            HELP &amp; INFORMATION
          </span>

          <h2>Frequently Asked Questions</h2>

          {/* <p>
            Find answers to common questions about our services,
            programmes, policies and procedures.
          </p> */}

          <span className="fsq-heading-accent" />
        </header>

        <div className="fsq-content">
          {loading && (
            <div className="fsq-message" role="status">
              <span className="fsq-spinner" aria-hidden="true" />
              Loading frequently asked questions...
            </div>
          )}

          {loadError && (
            <div className="fsq-message fsq-error" role="alert">
              <p>
                We could not load the frequently asked questions.
                Please try again.
              </p>

              <button
                type="button"
                className="fsq-retry"
                onClick={fetchFaqData}
              >
                <i
                  className="bi bi-arrow-clockwise"
                  aria-hidden="true"
                />
                Try Again
              </button>
            </div>
          )}

          {!loading && !loadError && faqData.length > 0 && (
            <div className="fsq-list">
              {faqData.map((item, index) => {
                const isActive = activeIndex === index;
                const answerId = `faq-answer-${index}`;
                const questionId = `faq-question-${index}`;

                return (
                  <article
                    className={`fsq-item ${
                      isActive ? "fsq-active" : ""
                    }`}
                    key={item.id || index}
                  >
                    <button
                      type="button"
                      id={questionId}
                      className="fsq-question"
                      aria-expanded={isActive}
                      aria-controls={answerId}
                      onClick={() => toggleFAQ(index)}
                    >
                      <span className="fsq-number">
                        {String(index + 1).padStart(2, "0")}
                      </span>

                      <span className="fsq-question-text">
                        {item.faq}
                      </span>

                      <span className="fsq-toggle" aria-hidden="true">
                        <i
                          className={`bi ${
                            isActive
                              ? "bi-dash-lg"
                              : "bi-plus-lg"
                          }`}
                        />
                      </span>
                    </button>

                    <div
                      id={answerId}
                      className={`fsq-answer ${
                        isActive ? "fsq-answer-open" : ""
                      }`}
                      role="region"
                      aria-labelledby={questionId}
                      hidden={!isActive}
                    >
                      <div className="fsq-answer-inner">
                        <HTMLDisplay
                          html={item.faqAns || ""}
                          textNo={100}
                          type="title"
                        />
                      </div>
                    </div>
                  </article>
                );
              })}
            </div>
          )}
        </div>

        <div className="fsq-footer">
          <span className="fsq-footer-icon" aria-hidden="true">
            <i className="bi bi-info-circle" />
          </span>

          <p>
            Need more information? Please contact the Ministry
            through the official contact channels.
          </p>
        </div>
      </div>
    </section>
  );
}

export default React.memo(FaqSection);
